import { Component, inject } from '@angular/core';

import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsFormFieldModule,
  RdsDialogRef,
  RDS_DIALOG_DATA,
  RdsIconsModule,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { KnowledgeFaq } from '../../../../models/knowledge';
import { POPUPS } from '../../../../constants/popups.constants';
import { RichTextEditorComponent } from '../../../shared/rich-text-editor/rich-text-editor.component';

@Component({
  selector: 'inexp-focus-faq-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RichTextEditorComponent
  ],
  templateUrl: './focus-faq-dialog.component.html',
  styleUrl: './focus-faq-dialog.component.scss',
})
export class FocusFaqDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusFaqDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as { faq?: KnowledgeFaq };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;

  form = this._fb.group({
    question: [this.data.faq?.question ?? '', Validators.required],
    answer: [this.data.faq?.answer ?? '', [Validators.required]],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
